export default __webpack_public_path__ + "static/media/apps-demo.9d9d30de.gif";